module.exports = __webpack_public_path__ + "img/404.13adee3c.svg";